<!--同业旅行社审核-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="代理商名称">
            <a-input v-decorator="['companyName']" placeholder="请输入代理商名称"></a-input>
          </a-form-item>
          <a-form-item label="代理商类型">
            <a-select
              class="form-control"
              :options="typesMap.companyTypeList"
              v-decorator="['companyType']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
          <a-form-item label="代理商状态">
            <a-select
              class="form-control"
              :options="typesMap.companyStatusList"
              v-decorator="['companyStatus']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
          <!-- <a-button class="app-btn" type="primary" @click="test(1)">???</a-button> -->
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">旅行社列表</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          rowKey="columnId"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        >
          <!-- 操作列 -->
          <template slot="handler" slot-scope="text, row">
            <div class="flex gap-5 justify-center text-primary-500">
              <span type="icon-chakan" class="cursor-pointer" @click="checkRow(row)">查看</span>
              <a-button
                v-if="row.companyStatus == 0 || row.companyStatus == 10"
                type="link"
                size="small"
                @click="enableDisable(row)"
              >
                {{ row.companyStatus == 0 ? '禁用' : '启用' }}
              </a-button>
            </div>
          </template>
        </a-table>
      </div>

      <a-modal v-model="modal.visible" :title="`绑定供应商账号`" @click="handleOk">
        <div>
          <a-form labelAlign="top" ref="form" :form="modal.form" class="form">
            <a-form-item label="请输入供应商手机号">
              <a-input
                v-decorator="['parentPhone', { rules: [{ required: true, message: '请输入供应商手机号' }] }]"
                placeholder="请输入供应商手机号"
              ></a-input>
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '60px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '代理商类型',
        align: 'center',
        dataIndex: 'companyType',
        customRender: text => {
          console.log('text', text)
          return <div>{text == 'COMPANY' ? '旅行社代理商' : '个人代理商'}</div>
        },
      },
      {
        title: '代理商名称/联系人',
        align: 'center',
        dataIndex: 'companyName',
      },
      {
        title: '联系电话',
        align: 'center',
        dataIndex: 'phone',
      },
      {
        title: '申请日期',
        align: 'center',

        dataIndex: 'createTime',
      },
      // {
      //   title: '绑定供应商账号',
      //   width: '15%',
      //   align: 'center',
      //   dataIndex: 'parentNickname',
      //   customRender: (text, row, index) => {
      //     return (
      //       <div>
      //         {!text && (
      //           <a
      //             onclick={() => {
      //               this.openModal(text, row)
      //             }}
      //           >
      //             去绑定
      //           </a>
      //         )}
      //         {text && <span>{text}</span>}
      //       </div>
      //     )
      //   },
      // },
      {
        title: '审核状态',
        align: 'center',
        dataIndex: 'companyStatus',
        customRender: (text, row, index) => {
          return (
            <div>
              <span>{this.translateType$t(text, 'companyStatusList')}</span>
            </div>
          )
        },
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'detail',
        scopedSlots: {
          customRender: 'handler',
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        companyStatusList: [
          { value: 0, label: '正常' },
          { value: 1, label: '审核中' },
          { value: 2, label: '审核失败' },
          { value: 10, label: '已禁用' },
        ],
        companyTypeList: [
          { value: 'COMPANY', label: '旅行社代理商' },
          { value: 'PERSONAL', label: '个人代理商' },
        ],
      }
    },
  },
  mounted() {
    this.doQuery()
  },
  methods: {
    // test() {
    //   this.$store.commit('SET_TOKEN', { accessToken: 4545465546545 })
    // },
    enableDisable(row) {
      this.$axios
        .put(`/user/admin/agent/status?companyId=${row.companyId}&status=${row.companyStatus == 0 ? 10 : 0}`)
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.doQuery()
          }
        })
    },
    doQuery() {
      this.$axios
        .get(`/user/admin/agent`, {
          params: {
            ...this.form.getFieldsValue(),
            page: this.pageNumber,
            limit: this.pageSize,
          },
        })
        .then(res => {
          this.countTotal = Number(res.count)
          this.dataSource = res.data
        })
    },
    checkRow(row) {
      console.log(row)
      if (!row.companyId) {
        return
      }

      this.$router.push({
        path: '/m/scopeMain/travelAgencyAudit/travelAgencyDetail',
        query: {
          companyId: row.companyId,
          type: 'DETAIL',
        },
      })
    },
    deleteRow(index) {
      this.doQuery()
      this.$notification.success({
        message: '删除成功',
      })
    },
    openModal(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.data = row
    },
    handleCancel() {
      this.modal.visible = false
    },
    handleOk() {
      this.$refs.form.validate((errors, values) => {
        if (!errors) {
          this.$axios
            .put(`/user/admin/agent/parent`, {
              params: {
                ...values,
                companyId: this.modal.data.companyId,
              },
            })
            .then(res => {
              if (res.success) {
                this.modal.visible = false
                this.doQuery()
              }
            })
        }
      })
    },
    doExport() {},
  },
}
</script>

<style lang="less"></style>
